import "../scss/style.scss";
import "./home.js";
import objectFitImages from 'object-fit-images';
import 'slick-carousel';

jQuery(function ($) {

// スムーススクロール
$(function(){
  $('a[href^="#"]').click(function(){
    var speed = 500;
    var href= $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top;
    $("html, body").animate({scrollTop:position}, speed, "swing");
    return false;
  });
});


// SP版メニュー クリックイベント
$(document).ready(function(){
  $('.js-nav-btn').on('click',function(){
    $(".js-nav").toggleClass('is-open');
    $(this).toggleClass('is-close');
  });
  $('.js-nav a[href^="#"], .js-nav-overlay').on('click',function(){
    $(".js-nav").removeClass('is-open');
    $('.js-nav-btn').removeClass('is-close');
  });
});


// acordion
$(function(){
  $('.js-acordion-btn').append('<span class="btn"></span>')
  $('.js-acordion-btn').on('click',function(){
    $('+ .js-acordion-content', this).slideToggle();
    $(this).toggleClass('is-open');
  });
});


// object-fit
$(function(){
  objectFitImages('.js-objectfit-img');
});


// tab
$(function() {
  $('.leadList li').click(function() {
    var index = $('.leadList li').index(this);
    tabBoxClick(index);
  });

  $('.resolveList li').click(function() {
    var index = $('.resolveList li').index(this);
    tabBoxClick(index);
  });
});

function tabBoxClick(index) {
  $('.tabBox').slideUp();
  if (index == '0') {
    $('.tabBox01').slideDown();
  }
  if (index == '1') {
    $('.tabBox02').slideDown();
  }
  if (index == '2') {
    $('.tabBox03').slideDown();
  }
  $('.resolveList li a').removeClass('active');
  $('.resolveList li a').eq(index).addClass('active');

  return false;
}

//スクロールされたらフェードイン & アップ
$(function() {
  $(window).scroll(function() {
    $('.fade-in, .fade-up').each(function() {
      var elemPos = $(this).offset().top;
      var scroll = $(window).scrollTop();
      var windowHeight = $(window).height();
      if (scroll > elemPos - windowHeight + windowHeight / 7) {
        $(this).addClass('scrollin');
      }
      // else {
      //     $(this).removeClass('scrollin');
      // }
    });
  });
});

});